import { render, staticRenderFns } from "./method.vue?vue&type=template&id=2da0076d&scoped=true&"
import script from "./method.vue?vue&type=script&lang=js&"
export * from "./method.vue?vue&type=script&lang=js&"
import style0 from "./method.vue?vue&type=style&index=0&id=2da0076d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da0076d",
  null
  
)

export default component.exports